// extracted by mini-css-extract-plugin
module.exports = {"noteToolbar":"Toolbar_noteToolbar__35I3K","shortcut":"Toolbar_shortcut__3RdQu"};